
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import Vue from 'vue';

import StatusBar from '../components/StatusBar.vue';
import PopupPickerSelector from '../components/PopupPickerSelector.vue';
import InlineSwitch from '../components/InlineSwitch.vue';
import InlineCheckBox from '../components/InlineCheckBox.vue';

import Datetime from 'vux/src/components/datetime/index.vue';
import Group from 'vux/src/components/group/index.vue';
import XDialog from 'vux/src/components/x-dialog/index.vue';
import PopupPicker from 'vux/src/components/popup-picker/index.vue';
import { TransferDomDirective as TransferDom } from 'vux/src/directives/transfer-dom/index.js';

import utils from '../utils/index';
import CONSTANTS from '../constants/index';
import { RISK_OPTION, RISK_LIMITS_LINK } from '../constants/index';
import { promises } from 'fs';
import { inspect } from 'util';
import { Popup } from 'vant';
import SNKH5Uploader from 'snk-image-js/lib/h5/uploader'
const cloudImageBaseURL = process.env.VUE_APP_CLOUDIMAGE_API_URL


export default {
name: 'home',
data() {
return {
uploaderInstance: {},
servicesRisk: {
'030134':false,
'030135':false,
'030136':false,
'030137':false,
},
vas: ['030134', '030135', '030136', '030137'], // 增值服务
dateControl: null,
isShowAll: false,
isCalculatingPremiun: false,
hasCalPremiunFlag: false,
calPremiumResult: {}, // 保费试算结果
defaultQuoteRisk: ['030101', '030102', '030104', '030105'], // 默认报价险种 : 车损险  三者险  司机险  乘客险
latelyVersionList: utils.deepClone(CONSTANTS.LATELY_VERSION_LIST), // 展示暂存单里的险别
motoFlag: false,
jqFlag: false,
syFlag: false,
choosenSylist: [],
riskTips: utils.deepClone(CONSTANTS.RISK_TIPS),
newRiskList: utils.deepClone(CONSTANTS.COVERAGE_NEW),
syRiskList: utils.deepClone(CONSTANTS.COVERAGE_List).filter(item => item.kindCode !== '021'),
syRisk: utils.deepClone(CONSTANTS.SY_RISK),
jqRisk: utils.deepClone(CONSTANTS.JQ_RISK),
PICKER_OPTIONS: {
'030102': [],
'030104': [],
'030105': [],
'030110': [],
'030112': [],
'030120': [],
'030134': [],
'030139': [],
'030140': [],
'rate030101': [],
'rate030102': [],
'rate030104': [],
'rate030105': [],
'03013701':[],
},
DEDUC_OPTIONS: [],
costCom: [],
isSelectModel: false, // 车型不一致弹窗
modelInfo: [] 
}
},
computed: {
...mapGetters({
getSyRisk: 'quote/getSyRisk',
getJqRisk: 'quote/getJqRisk',
getSwitchList:'quote/getSwitchList'
}),
...mapState({
minuteList: 'minuteList',
flowId: 'flowId',
quoteInfo: state => state.quote.quoteInfo,
electronicPolicyFlag: state => state.quote.electronicPolicyFlag,

switchList: state => state.quote.switchList,
insuredTips: (state) => state.insuredTips,
applicantTips: (state) => state.applicantTips,
cacheRecordInfo: (state) => state.quote.cacheRecordInfo,
isHc: state => state.isHc,
isSdjg: state => state.isSdjg,
sdQuoteInfo: state => state.quote.sdQuoteInfo,
}),
isShowSy() {

return !this.motoFlag
},
deptNo() { // 机构代码
return (
this.quoteInfo.base &&
this.quoteInfo.base.companyCode &&
this.quoteInfo.base.companyCode.slice(0, 4)
);
},
annualInspectionAge() {
/**
* 年检车龄计算公式：[3个月 +（保险止期年-初登日期的年）*12  +（保险止期月-初登日期的月） +[（保险止期日-初登日期的日）小于0则减1个月，否则不减]]/12，；
* 结果舍去小数。
* 大于等于6年，需过线1，否则免过线0（赠送1次）
*/
let _syEndDate = utils.beautyFormatDate(`${this.getSyRisk.endDate}`, 'yyyy-mm-dd'),
_v_singeinDate = utils.beautyFormatDate(`${this.quoteInfo.vehicle.singeinDate}`,'yyyy-mm-dd'),
_endDate = new Date(_syEndDate.replace(/[-]/g, '/')),
_endDateY = _endDate.getFullYear(),
_endDateM = _endDate.getMonth() + 1,
_endDateD = _endDate.getDate(),
_singeinDate = new Date(_v_singeinDate.replace(/[-]/g, '/')),
_singeinDateY = _singeinDate.getFullYear(),
_singeinDateM = _singeinDate.getMonth() + 1,
_singeinDateD = _singeinDate.getDate(),
_subM = _endDateD - _singeinDateD > 0 ? 0 : -1,
age = Math.floor((3 + (_endDateY - _singeinDateY) * 12 + (_endDateM - _singeinDateM) + _subM) / 12);
return age;
},
},
components: {
StatusBar,
InlineCheckBox,
Datetime,
Group,
PopupPickerSelector,
PopupPicker,
InlineSwitch,
XDialog,
[Popup.name]:Popup
},
directives: {
TransferDom,
},
methods: {
...mapMutations({
setRiskList: 'quote/setRiskList',
clearRiskList: 'quote/clearRiskList',
setJqrisk: 'quote/setJqrisk',
setSyrisk: 'quote/setSyrisk',
setQuoteInfo: 'quote/setQuoteInfo',
setRiskFlag: 'quote/setRiskFlag',
setCalPremiumResult: 'quote/setCalPremiumResult'
}),
...mapActions({
copy: 'quote/copy',
queryCoverQuote: 'quote/queryCoverQuote',
depreciation: 'quote/depreciation',
queryVhlTaxRelief: 'quote/queryVhlTaxRelief',
officialApply: 'quote/officialApply',
}),

getTaxRelifFlag() {
const taxMap = {
'01': '拒缴',
'02': '缴税',
'03': '完税',
'04': '减税',
'05': '免税',
'06': '补税并纳税'
};
const flag = (this.calPremiumResult &&
this.calPremiumResult.vhlTax &&
this.calPremiumResult.vhlTax.taxRelifFlag) || '';
return taxMap[flag] || '';
},

getFuelType() {



const fuelTypeKey = this.calPremiumResult.vhlTax.fuelType;
let fuelType = ''

if (this.deptNo === '0107') {

const found = CONSTANTS.BJ_POWER_TYPE_LIST.find(item => item.key === fuelTypeKey);
fuelType = found.name;
} else {

const found = CONSTANTS.POWER_TYPE_LIST.find(item => item.key === fuelTypeKey);
fuelType = found.name;
}
return fuelType;
},

async getQuotaLimitList() {
try {
const { vehicle, base } = this.quoteInfo
let useType = '02'

if (vehicle.carKindCode === '100' && Number(vehicle.seatCount) <= 9 && base.busiAttrConfig.useNatures === '02') {
useType = '01'
}
const data = {
useNatures: base.busiAttrConfig.useNatures, // 1107 新加的参数
attachNature: vehicle.attachNature, // 1107 新加的参数
carKindCode: vehicle.carKindCode, // 1107 新加的参数
orgNo: base.companyCode,
useType
}
const res = await $http.queryAutoRiskQuotaLimitList({ data })
if (res.resultCode === '0' && res.result && res.result.length > 0) {

const szx = res.result.find(item => item.riskType === '030102')
if (!szx) return
this.syRiskList.forEach(risk => {
if (risk.kindCode === '030102') {

risk.sumInsured = szx.quotaLimit
}
})
}
} catch (error) {
console.log(error);
}
},
handleShow(kindCode) {
let vm = this;
let _show = true;
if (vm.vas.includes(kindCode)) {

}
return _show;
},
handleReadonly(kindCode) {
let vm = this;
let _readonly = false;
if (vm.vas.includes(kindCode)) {
_readonly = vm.servicesRisk[kindCode];
}
return _readonly;
},
handleZzfw(riskList) {

let vm = this;
let _sy = riskList && riskList.find(item => item.riskCode == '0312');
let _coverageList = _sy && _sy.coverageList;




for (let index = 0, len = vm.syRiskList.length; index < len; index++) {
let item = vm.syRiskList[index];
if (vm.vas.includes(item.kindCode)) {
let _coverageList_item = _coverageList && _coverageList.find(x=>x.kindCode==item.kindCode);
let _status = _coverageList ? !!_coverageList_item : false;

item.isShow = _status;
item.checked = _status;
item.quantity = _status && _coverageList_item.quantity || 0 ;

}
}

},
initalRiskValue() {

this.syRiskList.forEach((item,index) => {



if(item.kindCode === '030140'){
let insured_030140 = this.PICKER_OPTIONS['030140'].find( opt => opt.value== item.sumInsured )
if(!insured_030140) {
item.sumInsured = '200000'
}
}
});

},
initalRiskOption() {

for (let opt in this.PICKER_OPTIONS) {
let option = [
RISK_OPTION[opt].premiumList
];
if (opt === '030112') {
option.push(RISK_OPTION[opt].premiumList2);
}
this.PICKER_OPTIONS[opt] = option;
}

this.DEDUC_OPTIONS.push(RISK_OPTION['deductibleList']);

let _risk_cost = this.syRiskList.find(item => item.kindCode === '030112');
this.costCom[0] = _risk_cost ? _risk_cost.unitInsured : 0;
this.costCom[1] = _risk_cost ? _risk_cost.quantity : 0;
},
initalRiskLimit() {

if (this.quoteInfo.vehicle.seatCount > 9) {
let vas = ['030134', '030135', '030136', '030137']; 
this.syRiskList = this.syRiskList.filter(item => vas.indexOf(item.kindCode) < 0);
}
},
getInsuranceType(kindCode) {
let input = ['030101']; 
let input2 = ['030135', '030136', '030137']; 
let input3 = ['030144']; 
let input4 = ['030141', '030142', '030145', '030146']; 
let picker = ['030102', '030110', '030120', '030139','030140']; 
let picker2 = ['030134']; 
let picker3 = ['rate030101', 'rate030102', 'rate030104', 'rate030105']; 
let complex = ['030104', '030105']; 
let complex2 = ['030112'] 
let typeObj = {
input,
input2,
input3,
input4,
picker,
picker2,
picker3,
complex,
complex2
}
for (let key in typeObj) {
if (typeObj[key].indexOf(kindCode) > -1) {
return key;
}
}
return 'others';
},




getRiskLimits(riskCode) {
let primarys = [];
let risk_limits = RISK_LIMITS_LINK;
for (let i = 0; i < risk_limits.length; i++) {
let secondarys = risk_limits[i].secondary;
secondarys.indexOf(riskCode) > -1 && primarys.push(risk_limits[i].primary);
}
if (primarys.length === 0) {
return true;
} else {
for (let m = 0; m < primarys.length; m++) {
let _primary = this.syRiskList.find(item => item.kindCode === primarys[m]);
if (_primary.checked) {
return true;
}
}
return false;
}
},

hasCoverageSd(kindCode) {
if (this.sdQuoteInfo && this.sdQuoteInfo.riskList) {
const riskSy = this.sdQuoteInfo.riskList.find(item => item.riskCode === CONSTANTS.SY_RISK_CODE) || {};
if (Array.isArray(riskSy.coverageList)) {
return riskSy.coverageList.findIndex(item => item.kindCode === kindCode) !== -1;
}
}
return false;
},
getRiskName(kindCode) {
for (let i = 0; i < CONSTANTS.COVERAGE_List.length; i++) {
if (kindCode === CONSTANTS.COVERAGE_List[i].kindCode) {
return CONSTANTS.COVERAGE_List[i].name;
}
}
return '';
},
getSeatcount(item) {
let seatCountArr = ['030105', '030142', '030146']; 
return seatCountArr.indexOf(item.kindCode) > -1 ? item.quantity + '座' : '';
},
formatCostPopupPicker(costCom) {
return `${costCom[0]}元*${costCom[1]}天`;
},
setSeatCount() {
let drivers = ['030104', '030141', '030145']; 
let passers = ['030105', '030142', '030146']; 
let seatCount = this.quoteInfo.vehicle.seatCount;
let driverCount = seatCount == 0 ? 0 : 1;
let passerCount = seatCount == 0 ? 0 : seatCount - 1;
for (let i = 0; i < this.syRiskList.length; i++) {
if (drivers.indexOf(this.syRiskList[i].kindCode) > -1) {
this.syRiskList[i].quantity = driverCount;
} else if (passers.indexOf(this.syRiskList[i].kindCode) > -1) {
this.syRiskList[i].quantity = passerCount;
}
}
},
showDatetime(initValue, type) {
let vm = this;
let opts = {
startDate: this.dateControl.startDate,
cancelText: '取消',
confirmText: '确定',
minuteList: this.minuteList,
value: initValue.slice(0, 16),
onConfirm(val) {
let startDate;
if (type == "jq") {
startDate = `${val}:00:00`;
} else if (type == "sy") {
startDate = `${val}:00`;
}
if (new Date(startDate.replace(/[-]/g, '/')) < new Date()) {
Toast("保险起期需大于当前时间");
return false;
}
if (type == "jq") {
vm.jqRisk.startDate = `${val}:00`;
} else if (type == "sy") {
vm.syRisk.startDate = val;
}
},
};
switch (type) {
case "jq":
opts = Object.assign({}, opts, {
format: 'YYYY-MM-DD HH',
})
break;
case "sy":
opts = Object.assign({}, opts, {
format: 'YYYY-MM-DD HH:mm',
})
break;
};

vm.$vux.datetime.show(opts);
},
jqStartDateChange(value) {
this.jqRisk.startDate = value + ":00";
if (new Date(this.jqRisk.startDate.replace(/[-]/g, '/')) < new Date()) {
Toast("保险起期需大于当前时间");
return false;
}
},
toNext() {
this.setRiskFlag({
jqFlag: this.jqFlag,
syFlag: this.syFlag,
});

let validate = this.validatePremium();
if (!validate.valid) {
this.$vux.toast.show({
text: validate.msg,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em'
});
return false;
}
this.$router.push({ name: 'SubmitOrder' });

},
formatValueFunction(val) {
let newVal = val.replace(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(:\d{2})/g, '$1');
return newVal
},

onSyStartDateChange(value) {
let vm = this;
let startDate = utils.beautyFormatDate(`${vm.syRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
vm.depreciation(startDate)
.then(actualValue => {
vm.resetInsured(actualValue);

})
.catch(err => {
Toast(err);
})
},

showRiskTips(riskIndex) {
let vm = this;
let TIPS_ITEM = this.riskTips[vm.syRiskList[riskIndex].kindCode]; 
if (!TIPS_ITEM) return;
let tips = TIPS_ITEM.tips;

vm.$vux.confirm.show({
title: '提示',
content: tips,
showCancelButton: false,
})
},

quotaChange(index) {
let vm = this;
let title, placeholder, upRatio, downRatio;
if (index === 0) {

title = '修改车辆损失险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
} else if (index == 2) {

title = '修改全车盗抢险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
} else if (index == 6) {

title = '修改自燃损失保险';

downRatio = 0.8;
placeholder = '保额最小值不能低于新车购置价20%';
}


let newAmt = Number(vm.quoteInfo.vehicle.purchasePrice); 
let vhlAmt = Number(vm.quoteInfo.vehicle.actualValue); 


vm.$vux.confirm.prompt(placeholder, {
title,
inputAttrs: { maxlength: 10 },
onCancel() {},
onConfirm(value) {
let valiAmt = Number(value); 
let minAmt = Number((vhlAmt - vhlAmt * downRatio).toFixed(2)); 

if (isNaN(Number(value))) {
vm.$vux.toast.show({
text: '请输入合法的保额数据',
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {
if (index == 0) { // 车损险

if (valiAmt < minAmt) {
vm.$vux.toast.show({
text: '保额修改不得低于' + minAmt,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {
vm.syRiskList[index].sumInsured = utils.limitToPercent(value);
}
} else if (index == 2 || index == 6) { // 盗抢险 和 自燃险
if (valiAmt < minAmt) {
vm.$vux.toast.show({
text: '保额修改不得低于' + minAmt,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em',
});
return;
} else {

vm.syRiskList[index].sumInsured = utils.limitToPercent(value);
}
}
}
}
});
},
updateCostCom(value) {
for (let i = 0; i < this.syRiskList.length; i++) {
if (this.syRiskList[i].kindCode === '030112') {
this.syRiskList[i].unitInsured = value[0];
this.syRiskList[i].quantity = value[1];
break;
}
}
},

/* T+1套上年方案逻辑(3种情况):
1: startDate < 当前时间 && 差值大于1年   year = 2018  date +1 再按2比较
2: startDate < 当前时间 && 差值小于1年   当前时间 + 1
3: startDate > 当前时间    			startDate +1
*/
reSetStartTimeAndInitRisk(type) {
/*
type : 'xzb' --> '续转保'后台返回的数据
*/
let vm = this;
let nowTime = new Date();
let nowTimeStr = `${nowTime.getFullYear()}-${nowTime.getMonth()+1}-${nowTime.getDate()}`;
if (vm.getJqRisk) {
let _jqRisk = utils.deepClone(vm.getJqRisk);
let tempTime;
if (type == "xzb") {
/* 如果是续转保: 需要取止期和当前时间比较
!!!!!!!!!   tempTime是存的止期 */

tempTime = utils.translateTimeDate(vm.getJqRisk.startDate.replace(/(\d{4})/, function(e) { return e - 0 + 1; }));
} else {
/*  如果是暂存单 或者默认设置的 : 取起期与当前时间比较
!!!!!!!!!   tempTime是存的起期 */
tempTime = utils.translateTimeDate(vm.getJqRisk.startDate);
}
let between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= -360) { // 超过一年
tempTime = tempTime.replace(/\d{4}/, nowTime.getFullYear())
between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= 0) {
_jqRisk.startDate = utils.recNexDate();
} else {
_jqRisk.startDate = utils.recNexDateSpecial(tempTime);
}
} else if (between <= 0) {
_jqRisk.startDate = utils.recNexDate();
} else if (between > 0 && type == "xzb") {
_jqRisk.startDate = utils.recNexDateSpecial(tempTime);
}
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate,'jq'); 
vm.setJqrisk(_jqRisk);
}
if (vm.getSyRisk) {
let _syRisk = utils.deepClone(vm.getSyRisk);
let tempTime;
if (type == "xzb") {
/* 如果是续转保: 需要取止期和当前时间比较
!!!!!!!!!   tempTime是存的止期 */
tempTime = utils.translateTimeDate(vm.getSyRisk.startDate.replace(/(\d{4})/, function(e) { return e - 0 + 1; }));
} else {
/*  如果是暂存单 或者默认设置的 : 取起期与当前时间比较
!!!!!!!!!   tempTime是存的起期 */
tempTime = utils.translateTimeDate(vm.getSyRisk.startDate);
}
let between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= -360) {
tempTime = tempTime.replace(/\d{4}/, nowTime.getFullYear());
between = utils.daysBetween(tempTime, nowTimeStr);
if (between <= 0) {
_syRisk.startDate = utils.recNexDate();
} else {
_syRisk.startDate = utils.recNexDateSpecial(tempTime);
}
} else if (between <= 0) {
_syRisk.startDate = utils.recNexDate();
} else if (between > 0 && type == "xzb") {
_syRisk.startDate = utils.recNexDateSpecial(tempTime);
};
_syRisk.endDate = utils.countEndDate(_syRisk.startDate,'sy'); 

for (var i = 0; i < _syRisk.coverageList.length; i++) {
if (vm.latelyVersionList.indexOf(_syRisk.coverageList[i].kindCode) == -1) {
_syRisk.coverageList.splice(i, 1);
i--;
}
}
vm.setSyrisk(_syRisk);
}
},

getInitRiskInfo() {
let vm = this;
let liscenseNo = this.quoteInfo.vehicle.licenseNo;
let frameNo = this.quoteInfo.vehicle.frameNo;
let tempNoInfo = JSON.parse(localStorage.getItem('tempNoInfo')) || {};
let tempNo = tempNoInfo[liscenseNo] || tempNoInfo[frameNo];
vm.isCalculatingPremiun = true;
return new Promise((resolve, reject) => {
if (tempNo && vm.quoteInfo.riskList && vm.quoteInfo.riskList.length != 0) { // 有暂存单

vm.reSetStartTimeAndInitRisk();
resolve(true);
} else if (!tempNo || !vm.quoteInfo.riskList || vm.quoteInfo.riskList.length == 0) { // 续保 or 转保

vm.queryCoverQuote()
.then(riskList => {

if (riskList.length == 2) {
vm.initAndStoreRisk();
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 1 && riskList[0].riskCode == CONSTANTS.SY_RISK_CODE) { // 单商 --> 处理交强
vm.initAndStoreRisk('JQ');
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 1 && riskList[0].riskCode == CONSTANTS.JQ_RISK_CODE) { // 单交 --> 处理商业
vm.initAndStoreRisk('SY');
vm.reSetStartTimeAndInitRisk('xzb');
} else if (riskList.length == 0) {
vm.initAndStoreByDefault();
}
resolve(true);
})
.catch(err => {
vm.initAndStoreByDefault();
resolve(true);
});
} else { // 默认
vm.initAndStoreByDefault();
resolve(true);
}
})
},

initAndStoreRisk(TYPE) {
let vm = this;

let _jqRisk = utils.deepClone(CONSTANTS.JQ_RISK);
if (TYPE != 'JQ') {
_jqRisk.startDate = vm.getJqRisk.startDate;
} else {
_jqRisk.startDate = utils.recTodayDate().replace(/(\d{4})/, function(e) { return e - 1; });
}
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate,'jq'); 
/* _jqRisk.vhlTax.identifyNumber =_jqRisk.vhlTax.taxpayerIdentifier = vm.quoteInfo.owner.identifyNumber;
_jqRisk.vhlTax.certiType = vm.quoteInfo.owner.identifyType || '01'; */

vm.setJqrisk(_jqRisk);

if (TYPE == 'SY') {
let _syRisk = utils.deepClone(CONSTANTS.SY_RISK);
let _syRistList = [];
_syRisk.startDate = utils.recTodayDate().replace(/(\d{4})/, function(e) { return e - 1; });;
_syRisk.endDate = utils.countEndDate(_syRisk.startDate,'sy'); 

this.defaultQuoteRisk.forEach(kindCode => {
vm.syRiskList.forEach(syItem => {
if (kindCode == syItem.kindCode) {
_syRistList.push(syItem);
}
});
});
_syRisk.coverageList = _syRistList;

vm.setSyrisk(_syRisk);
}
},

initAndStoreByDefault() {
let vm = this;
let _ristList = [],
_syRistList = [];
let _jqRisk = utils.deepClone(CONSTANTS.JQ_RISK),
_syRisk = utils.deepClone(CONSTANTS.SY_RISK);


_jqRisk.startDate = utils.recNexDate();
_jqRisk.endDate = utils.countEndDate(_jqRisk.startDate,'jq'); 
/* _jqRisk.vhlTax.identifyNumber =_jqRisk.vhlTax.taxpayerIdentifier = vm.quoteInfo.owner.identifyNumber;
_jqRisk.vhlTax.certiType = vm.quoteInfo.owner.identifyType || '01'; */


_syRisk.startDate = utils.recNexDate();
_syRisk.endDate = utils.countEndDate(_syRisk.startDate,'sy'); 

this.defaultQuoteRisk.forEach(kindCode => {
vm.syRiskList.forEach(syItem => {
if (kindCode == syItem.kindCode) {
_syRistList.push(syItem);
}
});
});
_syRisk.coverageList = _syRistList;
_ristList = [_jqRisk, _syRisk];


vm.setRiskList(_ristList);
},


initRiskInfoShowing(actualValue) {
let vm = this;

if (vm.getJqRisk) {
vm.jqFlag = true;

vm.jqRisk = utils.deepClone(vm.getJqRisk);

}

if (vm.getSyRisk) {
vm.syFlag = true;

vm.syRisk = utils.deepClone(vm.getSyRisk);

}

if (this.isSdjg) {
if (!vm.jqRisk.coverageList || vm.jqRisk.coverageList.length == 0) {
vm.jqRisk.coverageList = [{
"kindCode": "BZ",
"kindInd": "1",
"sumInsured": 200000
}];
} else if (!vm.jqRisk.coverageList[0].sumInsured) {
vm.jqRisk.coverageList[0].sumInsured = 200000;
}
}

vm.syRiskList.forEach((defaultItem, defaultIndex) => {
if (!vm.getSyRisk || !vm.getSyRisk.coverageList) {
return;
}

if(defaultItem.kindCode === '030137'&&!defaultItem.checked){
defaultItem.valueType = this.annualInspectionAge >= 6 ? '1' : '0';;
}
vm.getSyRisk.coverageList.forEach(syItem => {
if (defaultItem.kindCode === syItem.kindCode) {

syItem.checked = true;

if (this.isSdjg) {
const insuranceType = this.getInsuranceType(syItem.kindCode);
if (insuranceType === 'complex') {
if ((syItem.sumInsured && !syItem.unitInsured) || (syItem.unitInsured && !syItem.quantity)) {
const drivers = ['030104']; 
const passers = ['030105']; 
const seatCount = this.quoteInfo.vehicle.seatCount;
const driverCount = seatCount == 0 ? 0 : 1;
const passerCount = seatCount == 0 ? 0 : seatCount - 1;
if (drivers.includes(syItem.kindCode) && driverCount) {
syItem.quantity = syItem.quantity || driverCount;
syItem.unitInsured = syItem.unitInsured || (syItem.sumInsured / syItem.quantity);
} else if (passers.includes(syItem.kindCode) && passerCount) {
syItem.quantity = syItem.quantity || passerCount;
syItem.unitInsured = syItem.unitInsured || (syItem.sumInsured / syItem.quantity);
}
}
}
}
Vue.set(vm.syRiskList, defaultIndex, utils.deepClone(syItem));

if (syItem.kindCode === '030112') {
vm.costCom[0] = syItem.unitInsured;
vm.costCom[1] = syItem.quantity;
}

if (syItem.kindCode === '030101' || syItem.kindCode === '030102' || syItem.kindCode === '030104' || syItem.kindCode === '030105') {
if (syItem.deductibleRate && syItem.deductibleRate > 0) {
for (let i = 0; i < vm.syRiskList.length; i++) {
if (vm.syRiskList[i].kindCode === `rate${syItem.kindCode}`) {
vm.syRiskList[i].checked = true;
vm.syRiskList[i].disabled = false;
vm.syRiskList[i].rate = syItem.deductibleRate;
break;
}
}
}
}
}
});
});
this.resetInsured(actualValue); 
this.syRiskSwitch(this.syFlag);
},

initRiskInfoShowingByMoto() {
let vm = this;

if (vm.getJqRisk) {
vm.jqFlag = true;

vm.jqRisk = utils.deepClone(vm.getJqRisk);
}
},


resetInsured(actualValue) {
let vm = this;
vm.syRiskList.forEach((item, index) => {
if (['030101', '030103', '030108'].indexOf(item.kindCode) != -1) {
vm.syRiskList[index].sumInsured = actualValue;
}
});
},

encapRiskSY() {
let vm = this;
let riskList = [];

if (vm.jqFlag) {
let jqRisk = utils.deepClone(vm.jqRisk);
jqRisk.startDate = utils.beautyFormatDate(`${jqRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
jqRisk.electronicPolicyFlag = vm.electronicPolicyFlag ? '1' : '';
jqRisk.effectFlag = jqRisk.startDate.split(' ')[1] == '00:00:00' ? '0' : '1'; 
riskList.push(jqRisk);
}


if (vm.syFlag) {
let syRiskList = [];
let _syRiskList = utils.deepClone(vm.syRiskList);
let syRisk = utils.deepClone(vm.syRisk);

_syRiskList.forEach((item, index) => {

let disabledZzfw = vm.vas.includes(item.kindCode) && !vm.servicesRisk[item.kindCode];
if (item.checked && !item.disabled) {
delete item.checked;
delete item.disabled;
syRiskList.push(item);

vm.syRiskList[index].isShow = true;
} else {
vm.syRiskList[index].isShow = false;
}
});


let hasDeductibleRate = false;
for (let i = 0; i < syRiskList.length; i++) {
let _risk = syRiskList[i];
let _code = _risk.kindCode;
if (_code === '030101' || _code === '030102' || _code === '030104' || _code === '030105') {
let _rate_risk = syRiskList.filter(item => item.kindCode === `rate${_code}`)[0];
if (_rate_risk) {
_risk.deductibleRate = _rate_risk.rate || '0';
hasDeductibleRate = true;
} else {
_risk.deductibleRate = '0';
}
}
}


if (hasDeductibleRate) {
let deductible_risk = syRiskList.filter(item => item.kindCode === '021')[0];
if (!deductible_risk) {
syRiskList.push({
deductible: '',
kindCode: '021',
kindInd: '2',
quantity: '',
sumInsured: ''
});
}
} else {
let deductible_risk = syRiskList.filter(item => item.kindCode === '021')[0];
if (deductible_risk) {
syRiskList = syRiskList.filter(item => item.kindCode !== '021');
}
}

syRisk.coverageList = vm.choosenSylist = syRiskList.filter(item => item.kindCode.indexOf('rate') < 0);

syRisk.startDate = utils.beautyFormatDate(`${syRisk.startDate}`, 'yyyy-mm-dd hh:mm:ss');
syRisk.electronicPolicyFlag = vm.electronicPolicyFlag ? '1' : '';
syRisk.effectFlag = syRisk.startDate.split(' ')[1] == '00:00:00' ? '0' : '1'; 
riskList.push(syRisk);
}
return riskList;
},

setPremium(riskList) {
let vm = this;
vm.calPremiumResult = { totalPremium: 0 };
riskList.forEach(risk => {
if (risk.riskCode == "0312") {

risk.coverageList.forEach(coveragItem => {
vm.calPremiumResult[coveragItem.kindCode] = parseFloat(coveragItem.grossPremium).toFixed(2);
if (coveragItem.kindCode === '030101' || coveragItem.kindCode === '030102' || coveragItem.kindCode === '030104' || coveragItem.kindCode === '030105') {
if (coveragItem.nonDeductiblePremium && coveragItem.nonDeductiblePremium !== '0') {
vm.calPremiumResult[`rate${coveragItem.kindCode}`] = parseFloat(coveragItem.nonDeductiblePremium).toFixed(2);
}
}
});
vm.calPremiumResult.syTotalPremium = risk.sumGrossPremium.toFixed(2) || "0"; 
vm.calPremiumResult.applySumDiscount = (risk.applySumDiscount * 10).toFixed(3); 
vm.calPremiumResult.totalPremium += risk.sumGrossPremium; 
vm.calPremiumResult.syTotalPremiumSaved = (risk.sumGrossPremium * ((1 - risk.applySumDiscount) / risk.applySumDiscount)).toFixed(2); 

} else if (risk.riskCode == "0301") {
vm.calPremiumResult.jqTotalPremium = risk.sumGrossPremium.toFixed(2) || "0"; 
vm.calPremiumResult.vhlTax = risk.vhlTax; 
vm.calPremiumResult.totalPremium += risk.sumGrossPremium; 
vm.calPremiumResult.totalPremium += (risk.vhlTax.sumPayTax || 0); 

}
});
vm.calPremiumResult.totalPremium = vm.calPremiumResult.totalPremium.toFixed(2); 
vm.setCalPremiumResult(vm.calPremiumResult);
},
validate() {
let vm = this;
let check = {
msg: '',
valid: true
};
if (!vm.jqFlag && !vm.syFlag) {
check = {
msg: '请至少选择一种险种',
valid: false
}
}
if (vm.syFlag && vm.choosenSylist.length == 0) {
check = {
msg: '请至少选择一种商业险险种',
valid: false
}
}
return check;
},

validateAllSyRisk() {
const timesObj = {
'030134': 'roadRescueService', //道路救援服务次数
'030135': 'vehicleSafetyInspect', //车辆安全检测次数
'030136': 'drivingServices', //代驾服务次数
'030137': 'inspectServices' //代为送检服务次数
};
for (let i = 0; i < this.syRiskList.length; i++) {
let _risk = this.syRiskList[i];

if (!_risk.checked) {
continue;
}

let insuranceType = this.getInsuranceType(_risk.kindCode);
let riskName = this.getRiskName(_risk.kindCode);
let validInfo = null;
switch (insuranceType) {
case 'input2':
let timesName = timesObj[_risk.kindCode];
let maxTime = this.switchList[timesName];
validInfo = this.validateTimes(_risk.quantity, riskName, maxTime);
break;
case 'input3':
validInfo = this.validateSumInsured(_risk.sumInsured, riskName);
break;
case 'input4':
validInfo = this.validateSumInsured(_risk.unitInsured, riskName);
break;
default:
break;
}

if (validInfo && !validInfo.valid) {
return validInfo;
}
}

return { valid: true, msg: '' };
},

validateTimes(value, riskName, maxTime) {
maxTime = (maxTime || maxTime === 0) ? maxTime : 10;
let regPremium = /^[1-9]\d*$/;
if (!value && value !== 0) {
return { valid: false, msg: `请输入${riskName}次数` };
} else if (Number(value) < 1) {

return { valid: true, msg: '' };
} else if (Number(value) > maxTime) {
return { valid: false, msg: `${riskName}次数不能大于${maxTime}次` };
} else if (!regPremium.test(value)) {
return { valid: false, msg: `${riskName}次数只能为整数` };
} else {
return { valid: true, msg: '' };
}
},

validateSumInsured(value, riskName) {
let regPremium = /^\d+(?=\.{0,1}\d+$|$)/;
if (!value && value !== 0) {
return { valid: false, msg: `请输入${riskName}保额` };
} else if (Number(value) <= 0) {
return { valid: false, msg: `${riskName}保额不能小于或等于0` };
} else if (!regPremium.test(value)) {
return { valid: false, msg: `请输入正确的${riskName}保额` };
} else {
return { valid: true, msg: '' };
}
},

validatePremium() {
for (let item in this.calPremiumResult) {
if (item.indexOf('0301') > -1) {
let premium = this.calPremiumResult[item]; 
let riskName = this.getRiskName(item);
if (['030134', '030135', '030136', '030137'].includes(item)) { //道路救援险、车辆安全检测、代驾服务、代为送检保费可以为0，但不能为空
if (!premium && premium !== 0) {
return { valid: false, msg: `${riskName}保费为空，不允许下一步` };
}
} else { //其他险别保费不能为0，也不能为空
if (!premium || premium == '0' || premium == '0.0' || premium == '0.00') {
return { valid: false, msg: `${riskName}保费为0，不允许下一步` };
}
}
}
}
return { valid: true, msg: '' };
},
reCalAmount() {
let vm = this;
vm.calAmount()
.catch(err => {
vm.isCalculatingPremiun = false;
if (!err.notRealPromiseException) { // 一切正常，只是通过 catch 方法来中止 promise chain
vm.$vux.toast.show({
text: err,
time: 2000,
type: 'text',
position: 'middle',
'is-show-mask': true,
width: '20em'
});
}
});
},

calAmount() {
let vm = this;
const storeJqVhlTax = vm.getJqRisk && vm.getJqRisk.vhlTax;
if (vm.jqFlag && storeJqVhlTax && storeJqVhlTax.taxRelifFlag) {
vm.jqRisk.vhlTax = utils.deepClone(storeJqVhlTax);
}

let riskList = this.encapRiskSY();

this.isShowAll = false;
let imglist = JSON.parse(sessionStorage.getItem('imgIdListHistory'))
imglist && riskList.forEach((item) => {
item['imageId'] = imglist.imageIds[0]
})

let validate = this.validate();
if (!validate.valid) {
return Promise.reject(validate.msg);
}


let validate_risk = this.validateAllSyRisk();
if (!validate_risk.valid) {
return Promise.reject(validate_risk.msg);
}


if (!vm.isCalculatingPremiun) {
vm.isCalculatingPremiun = true;
}

if (vm.quoteInfo.shanghai && riskList && (riskList[0].vhlTax || riskList[1].vhlTax)) {
if (riskList[0].vhlTax) {
riskList[0].vhlTax.relifReason = '';
riskList[0].vhlTax.taxItemDetailCode = '';
} else {
riskList[1].vhlTax.relifReason = '';
riskList[1].vhlTax.taxItemDetailCode = '';
}
}
return $http.quote({
query: {
flowId: this.flowId,
},
data: {
riskList,
quotationWay: '0',
},
showLoading: false,
closeLoading: false,
})
.then(res => {

if (res.result && res.result.riskList && res.result.riskList.length && res.result.riskList.some(i => i.ilogInfos && i.ilogInfos.length)) {
const riskList = res.result.riskList || []
let touchCRuleMark = false
riskList.forEach(item => {
touchCRuleMark = item.ilogInfos.some(i => i.preRuleType === 'C')
})
if (touchCRuleMark) {
this.$vux.alert.show({
title: '温馨提示',
content: '暂不支持您的爱车投保',
});
return Promise.reject({
notRealPromiseException: true,
});

}
}
let jqRisk = {};
if(!utils.isEmpty(res.result)){
let riskList = res.result && res.result.riskList;
if(riskList && riskList.length){
riskList.forEach((item)=>{
if(item.riskCode==='0301'){
jqRisk = item;
}
})
}
if (!utils.isEmpty(jqRisk) &&
jqRisk.vhlTax &&
(jqRisk.vhlTax.taxRelifFlag === '04' || jqRisk.vhlTax.taxRelifFlag === '05')) {

if (!jqRisk.vhlTax.taxCompancyCode ||
!jqRisk.vhlTax.taxCompancyName ||
!jqRisk.vhlTax.paidFreeCertificate) {
this.$vux.alert.show({
title: '温馨提示',
content: '暂不支持您的爱车投保',
});
return Promise.reject({
notRealPromiseException: true,
});
}
}
}
if (!(vm.getSwitchList.ocrInsuredSwitch && res.resultCode === '0')) {

vm.isCalculatingPremiun = false;
}
let newQuoteInfo = utils.deepClone(res.result);
if(!utils.isEmpty(newQuoteInfo) && !utils.isEmpty(newQuoteInfo.riskList) ){
vm.handleZzfw(newQuoteInfo && newQuoteInfo.riskList);
}
if (res.resultCode == 0) {
if (!newQuoteInfo) return
if (!newQuoteInfo.base) return
















if (vm.getSwitchList.ocrInsuredSwitch) {

vm.initUploaderInstance(res.result).then((historyImg) => {

if (historyImg && historyImg.length) {
console.log('先删除再上传');
vm.uploaderInstance.deleteFile({
imgIdList: historyImg.map(item => item.imgId),
success: () => {

vm.imgUpload(newQuoteInfo)
},
error: err => {
console.log(err);
}
})
} else {
vm.imgUpload(newQuoteInfo)
}
})
}

vm.setPremium(newQuoteInfo.riskList);

/* newQuoteInfo.riskList.forEach(item => {
item.clauseList = (item.coreClauseList || []).filter((clauseItem)=>{
return !(clauseItem.isNeeded === '0' && clauseItem.isModify === '1');
});
}); */

vm.setQuoteInfo(newQuoteInfo);

vm.officialApply();
} else if (res.resultCode == '3') { // 重复投保 or 转保 or 车型不一致
let reInsureList = newQuoteInfo.reInsureList;

if (reInsureList && reInsureList.length == 2) {
if (!reInsureList[0].expireDate || !reInsureList[1].expireDate) {
return Promise.reject(res.errorMsg);
} else {

reInsureList = reInsureList.filter(item => {
return item.kindCode == '0301';
});
let expireDate = utils.translateTimeDate(reInsureList[0].expireDate + ":00:00"); 
let tempTime = utils.translateTimeDate(vm.jqRisk.startDate); 
let between = utils.daysBetween(tempTime, expireDate);
if (between <= 0) {
return Promise.reject(res.errorMsg);
}
}
} else if (reInsureList && reInsureList.length == 1 && reInsureList && reInsureList.riskCode == '0301') {
if (!reInsureList[0].expireDate) {
return Promise.reject(res.errorMsg);
} else {
let expireDate = utils.translateTimeDate(reInsureList[0].expireDate + ":00:00"); 
let tempTime = utils.translateTimeDate(vm.jqRisk.startDate); 
let between = utils.daysBetween(tempTime, expireDate);
if (between < 0) {
return Promise.reject(res.errorMsg);
}
}
} else {
return Promise.reject(res.errorMsg);
}


var carModelInfos = newQuoteInfo.carModelInfos;
if (carModelInfos) { // 车型编码不一致
return Promise.reject(res.errorMsg);
}



Toast(res.errorMsg);

vm.setQuoteInfo(newQuoteInfo);
vm.setPremium(newQuoteInfo.riskList);

vm.officialApply();
} else if (res.resultCode == 'E11012') { // 行业车型不一致
if (data.result.policyInfo.carModelList && data.result.policyInfo.carModelList.length) {

window.setTimeout(function(){
vm.$set(that,'modelInfo',data.result.policyInfo.carModelList)
},0)

vm.$set(vm,'isSelectModel',true)
}
} else {
return Promise.reject(res.errorMsg);
}
})
.then(res => {

vm.hasCalPremiunFlag = true;
})
.catch(err => {
return Promise.reject(err);
})
},

imageUpdateStatus(quoteInfo) {
const vm = this
const imageIds = quoteInfo.riskList.map((item) => item.imageId)
const quotationNos = quoteInfo.riskList.map(
(item) => item.quotationNo
)
const data = {
imageIds,
quotationNos,
proposalNo: '',
status: '10',
}
$http
.updateImgStatus({
data,
})
.then((res) => {
console.log('imageUpdateStatus');

vm.isCalculatingPremiun = false;
})
.catch((err) => {
vm.isCalculatingPremiun = false;
console.log(err)
})
},

getTokenToImageUpload(quoteInfo) {

const imageIds = quoteInfo.riskList.map((item) => item.imageId)

const imageItemInfos = [
{

type: '1',
itemName: this.applicantTips ? quoteInfo.applicant.name : quoteInfo.owner.name,
itemNumber: this.applicantTips ? quoteInfo.applicant.identifyNumber : quoteInfo.owner.identifyNumber,
itemType: this.applicantTips ? quoteInfo.applicant.identifyType : quoteInfo.owner.identifyType
},
{

type: '2',
itemName: this.insuredTips ? quoteInfo.insured.name : quoteInfo.owner.name,
itemNumber: this.insuredTips ? quoteInfo.insured.identifyNumber : quoteInfo.owner.identifyNumber,
itemType: this.insuredTips ? quoteInfo.insured.identifyType : quoteInfo.owner.identifyType
},
{

type: '4',
itemName: quoteInfo.owner.name,
itemNumber: quoteInfo.owner.identifyNumber,
itemType: quoteInfo.owner.identifyType,
},
{

type: '5',
itemName: quoteInfo.vehicle.licenseNo,
itemNumber: quoteInfo.vehicle.frameNo,
},
]
const data = {
companyCode: quoteInfo.base.companyCode || '',
imageIds,
imageItemInfos,
operator: quoteInfo.base.operatorCode || '',
proposalNo: '',
step: '投保',
}
const option = {
data,
}
return $http
.getImageToken(option)
.then((res) => {
if (res.resultCode == '0') {
return res.result.token
} else {
Toast(res.errorMsg || '获取token失败')
}
})
.catch((err) => {
Toast(res.errorMsg || '获取token失败')
console.log(err)
})
},

initUploaderInstance(quoteInfo) {
const vm = this
return new Promise((resolve, reject) => {
const uploaderInstance = new SNKH5Uploader({
api: {
base: cloudImageBaseURL,

},
getToken: function(params) {
vm.getTokenToImageUpload(quoteInfo).then((token) => {
vm.uploadToken = token
params.success({
token
})
})
},
})
uploaderInstance.init({
success: function() {
uploaderInstance.queryFiles({

imgIdList: [],
success: res => {
resolve(res)
},
error: error => {
resolve(error.data || [])
console.log(error)
}
})
},
error: function(e) {
console.log(e)
},
})
vm.uploaderInstance = uploaderInstance
})
},

getFileFromUrl(url, fileName, code) {
return new Promise((resolve, reject) => {
const suffix = fileName.split('.').pop()
let blob = null;
const xhr = new XMLHttpRequest();
xhr.open("GET", url);
xhr.setRequestHeader('Accept', 'image/' + suffix);
xhr.responseType = "blob";

xhr.onload = () => {

blob = xhr.response;
let file= new File([blob], fileName, { type: 'image/' + suffix });
file.code = code

resolve(file);
};
xhr.onerror = (e) => {
reject(e)
};

xhr.send();
});
},
getImgFile() {
const arr = [
{
name: 'owner',
code: 'S001_0601'
},
{
name: 'vehicle',
code: 'S001_0701'
},
{
name: 'insured',
code: 'S001_0401'
},
{
name: 'applicant',
code: 'S001_0301'
}
]
const cacheRecordInfo = this.cacheRecordInfo
const proFiles = []
arr.forEach(item => {
const name = item.name
if (name === 'owner') {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
} else if (name === 'vehicle') {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
if (cacheRecordInfo[name].backSrc && cacheRecordInfo[name].backName) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
} else if (name === 'insured') {
if (!this.insuredTips) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].justSrc, cacheRecordInfo['owner'].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].backSrc, cacheRecordInfo['owner'].backName, item.code))
} else {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
} else if (name === 'applicant') {
if (!this.applicantTips) {
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].justSrc, cacheRecordInfo['owner'].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo['owner'].backSrc, cacheRecordInfo['owner'].backName, item.code))
} else {
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].justSrc, cacheRecordInfo[name].justName, item.code))
proFiles.push(this.getFileFromUrl(cacheRecordInfo[name].backSrc, cacheRecordInfo[name].backName, item.code))
}
}
})
return proFiles
},

imgUpload(newQuoteInfo) {
const vm = this

Promise.all(this.getImgFile()).then(files => {

const proUploads = []
files.forEach(file => {
const code = file.code
proUploads.push(vm.uploadImg(file, code))
})
Promise.all(proUploads).then(res => {


vm.imageUpdateStatus(newQuoteInfo)
}).catch(err => {

vm.isCalculatingPremiun = false;
console.log('err', err);
})
}).catch(err => {

vm.isCalculatingPremiun = false;
console.log('err', err);
})
},
uploadImg(file, code) {
return new Promise((resolve, reject) => {
let quality = 0

const uploaderInstance = this.uploaderInstance
if (file.size > 1 * 1024 * 1024) {
quality = 0.9
}
uploaderInstance.fileSelected(file, result => {
result.uploadNode = '投保' 
uploaderInstance.upload({
file: result.file,
quality: quality || 1,
pathData: {

typeCode: code,
},
VoData: result,
success: (res) => {
console.log('res-uploadImg-', res)
resolve(res)
},
error: (err) => {
resolve(err)
console.log('error-uploadImg', err)

},
})
})
})
},

syRiskSwitch(syFlag) {
if (!syFlag) { // 取消
this.syRiskList.forEach((item, riskIndex) => {
item.relatedInd = 0;
item.checked = false;
});
}
},

handleRiskClick(item) {
if (!this.getRiskLimits(item.kindCode)) {
let relation = this.riskTips[item.kindCode]; 
let rely = relation && relation.rely;
if (rely && rely.length > 0) {
this.$vux.confirm.show({
title: '提示',

content: `亲，请先投保主险！`,
showCancelButton: false
});
}
}
},
handleRiskCheck(item) {

if (item.checked && !this.syFlag) {
this.syFlag = true;
}

if (item.kindCode === '030105' && item.checked) {
this.setRiskState({ kindCode: '030104', checked: true });
}

if (item.kindCode === '030104' && !item.checked) {
this.setRiskState({ kindCode: '030105', checked: false });
}




if (!item.checked) {
let secondarys = [];
for (let i = 0; i < RISK_LIMITS_LINK.length; i++) {
if (RISK_LIMITS_LINK[i].primary === item.kindCode) {
secondarys = RISK_LIMITS_LINK[i].secondary;
break;
}
}
if (secondarys.length > 0) {
for (let i = 0; i < secondarys.length; i++) {
let riskCode = secondarys[i];
let primarys = this.findPrimary(riskCode, RISK_LIMITS_LINK);
let num = 0;
for (let j = 0; j < primarys.length; j++) {
let _checked = this.syRiskList.find(item => item.kindCode === primarys[j]).checked;
!_checked && num++;
}
if (primarys.length === num) {
this.setRiskState({ kindCode: riskCode, checked: false });
}
}
}
}
},
findPrimary(riskCode, riskList) {
let primarys = [];
for (let i = 0; i < riskList.length; i++) {
let secondarys = riskList[i].secondary;
secondarys.indexOf(riskCode) > -1 && primarys.push(riskList[i].primary);
}
return primarys;
},
setRiskState(obj) {
for (let i = 0; i < this.syRiskList.length; i++) {
if (obj.kindCode === this.syRiskList[i].kindCode) {
this.syRiskList[i].checked = obj.checked;
break;
}
}
},

handlePickerChange(item) {
if (item.kindCode === '030102') {
for (let i = 0; i < this.syRiskList.length; i++) {
if (this.syRiskList[i].kindCode === '030120') {
this.syRiskList[i].sumInsured = item.sumInsured;
break;
}
}
}
},

handleInputChange(item) {
let inputs = ['030141', '030142', '030145', '030146']; 
if (inputs.indexOf(item.kindCode) > -1) {
item.sumInsured = item.unitInsured * item.quantity;
}
},

selectModel(vhl){
this.quoteInfo.vehicle=utils.mergeObj(this.quoteInfo.vehicle,vhl,utils.deepClone(CONSTANTS.CAR_BEANS.vehicle));
if (!vhl.carKindCodeShow && !vhl.carKindCode) {

this.quoteInfo.vehicle.carKindCodeShow='11';
} else {
this.quoteInfo.vehicle.carKindCodeShow=CONSTANTS.BASE_BEAN.CLASSIDTOCARKINDSHOW[this.quoteInfo.vehicle.jqxClassId];
}
this.setQuoteInfo(this.quoteInfo);

this.$set(this,'isSelectModel',false);
}
},
watch: {
syRiskList: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
syRisk: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
jqRisk: {
deep: true,
handler(newVal, oldVal) {
this.hasCalPremiunFlag = false;
}
},
jqFlag(val) {
this.hasCalPremiunFlag = false;
},
syFlag(val) {
this.hasCalPremiunFlag = false;

this.syRiskSwitch(val);
},
},

created() {
if (this.isSdjg) {
this.syRiskList = utils.deepClone(CONSTANTS.COVERAGE_List_Sd).filter(item => item.kindCode !== '021')
}
this.motoFlag = this.quoteInfo && this.quoteInfo.vehicle && this.quoteInfo.vehicle.carKindCode === '400'; 

this.motoFlag || this.initalRiskOption();


this.motoFlag || this.setSeatCount();


this.motoFlag || this.initalRiskLimit();


this.motoFlag || this.initalRiskLimit();


this.initalRiskValue();
let vm = this;
vm.quoteInfo.jqFlag ? vm.jqFlag = true : '';
vm.quoteInfo.syFlag ? vm.syFlag = true : '';

vm.queryVhlTaxRelief()
.then(() => {


return Promise.all([vm.getInitRiskInfo(), vm.getQuotaLimitList()])
})
.then(() => {
const promiseLists = vm.motoFlag ? [ vm.queryVhlTaxRelief() ] : [ vm.depreciation(), vm.queryVhlTaxRelief() ];


return Promise.all(promiseLists)
.then(resultList => {
if (vm.motoFlag) {

this.initRiskInfoShowingByMoto();
} else {
let actualValue = resultList[0]; 
this.initRiskInfoShowing(actualValue);
}
return this.calAmount();
})
.catch(err => {
vm.isCalculatingPremiun = false;


if (!this.isSdjg) {
vm.clearRiskList();
vm.officialApply();
}
if (!err.notRealPromiseException) { // 一切正常，只是通过 catch 方法来中止 promise chain
Toast(err);
}
});
})
.catch(err => {
vm.isCalculatingPremiun = false;
let errMsg = err || "险种初始化出错！";
Toast(errMsg);
});



let nowTime = new Date();
this.dateControl = {
startDate: utils.beautyFormatDate(new Date(), 'yyyy-mm-dd'),
minHour: new Date().getHours(),
}
},
mounted() {
utils.stopVideo(this.flowId).then(()=>{
utils.startVideo('','',() => {
utils.createOperationVideo("LOAD_PAGE","选择方案");
})
})
},
beforeDestroy(){
utils.stopVideo(this.flowId).then(()=>{
utils.startVideo()
})
}
}
